export const fetchData = async (url, token) => {
    try {
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;  // Re-throw the error to handle it in the caller function
    }
  };
  